import { actionTooltipProps } from "@/ds";

export const FECHAR_LABEL = "Fechar";
export const FECHAR_TOOLTIP = actionTooltipProps(FECHAR_LABEL, { event: "hover" });

/** `pt.closeButton` do Dialog: o Prime não tem `tooltip` no X, então o testid dele vira o alvo do `FecharTooltip`. */
export const fecharPt = (testId: string) => ({ closeButton: { "data-testid": testId } });
